import { render, staticRenderFns } from "./MenusTab.vue?vue&type=template&id=0bd48809&"
import script from "./MenusTab.vue?vue&type=script&lang=js&"
export * from "./MenusTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports